import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { apiClient, LeaseUpdateTableLoaderResult } from "~/services/apiClient";
import { loadCookiesData } from "~/utils";
import { FormattedLeaseData } from "~/types/lease";

export async function LeaseUpdateTablePageLoader({
  request,
}: LoaderFunctionArgs): Promise<LeaseUpdateTablePageLoaderType | Response> {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");
  const authAccessInfo = await loadCookiesData(user?.uid || "");
  if (!authAccessInfo.success) return redirect("/explore");
  const { ownerID, ownerType } = authAccessInfo.data;

  const result = await apiClient.loader<LeaseUpdateTableLoaderResult>(
    "lease-update-table",
    { ownerID, ownerType }
  );

  if (!result.success || !result.data) {
    console.error("Failed to load lease update list:", result.error);
    return redirect("/explore");
  }

  return {
    leaseList: result.data.leaseList as FormattedLeaseData[],
  };
}

export type LeaseUpdateTablePageLoaderType = {
  leaseList: FormattedLeaseData[];
};
